import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';
import { useParams } from 'react-router-dom';
import "./user.css"

const UserFollowers = () => {
    const [userFollowers, setUserFollowers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const [isFriend, setIsFriend] = useState(null)
    const [isFollowing, setIsFollowing] = useState(null)

    const { user } = useParams()

    useEffect(() => {
        const checkIsFriend = async () => {
            try {
                const response = await api.get(`/users/${user}/check`)
                if (response) {
                    setIsFriend(response?.data)
                }
            } catch (error) {
                toast.error(error.response?.data.message)
            }
        }
        checkIsFriend()
    }, [user])

    useEffect(() => {
        const getUserFollowers = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/users/${user}/followers`, { params: { page } });
                setUserFollowers(response.data?.followers);

                if (response.data?.followers.length < 20) {
                    setHasMore(false)
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch followers");
            } finally {
                setIsLoading(false);
            }
        };

        getUserFollowers();
    }, [page, user]);

    const handleRefresh = async () => {
        setPage(1)
        setUserFollowers([])
    }

    const sendFollowRequest = async (id) => {
        try {
            const response = await api.post()
        } catch (error) {

        }
    }
    const sendUnfollowRequest = async (id) => {
        try {
            // console.log(id)
        } catch (error) {

        }
    }

    return (
        <div className='users-page-container'>
            <div className="userfriends-header">
                <h3>Followers</h3>
                {isFriend && <button className="add-frd-btn" onClick={() => sendUnfollowRequest(user)}>unfollow</button>}
                {!isFriend && <button className="add-frd-btn" onClick={() => sendFollowRequest(user)}>follow</button>}
            </div>
            <InfiniteScroll
                dataLength={userFollowers.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="friends-list">
                    {
                        isLoading && <Loader />
                    }
                    {!isLoading && userFollowers.length === 0 &&
                        <p className="not-found-msg">No followers found</p>
                    }
                    {
                        userFollowers && userFollowers.map((frd) => (
                            <UserCard user={frd} />
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    );
};

export default UserFollowers;
